import React from 'react';
import translate from '../../locales';
import { Drawer } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import ErrorIcon from '@material-ui/icons/Error';


const __t = translate;

const ContextValidationDrawer = ({ open, onClose, validationResult }) => {
    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
        >
            <div style={{ width: '60vw', height: '100vh', display: 'flex', flexDirection: 'column' }}>
                <div style={{ textAlign: 'center', fontSize: '1.2em', fontWeight: 'bold', paddingTop: '20px', paddingBottom: '10px', borderBottom: '1px solid #ccc' }}>{__t('validations')}</div>
                <div style={{ flexGrow: 1, overflowY: 'auto', padding: "5px", paddingTop: "10px", paddingBottom: "10px" }}>
                    {validationResult && validationResult.hasErrors ?
                        <>
                            <div style={{ display: 'flex', alignItems: 'end', fontSize: '1.1em' }}>
                                <ErrorIcon style={{ color: 'red', marginRight: '5px' }} />
                                {__t('errors')}
                            </div>
                            <ul style={{ paddingLeft: '30px' }}>
                                {validationResult.rateValidations && validationResult.rateValidations.map((rv, index) => (
                                    <li key={'r' + index}>{__t('error_rate_has_validation_errors')}: {rv.name}</li>
                                ))}
                                {validationResult.bucketValidations && validationResult.bucketValidations.map((error, index) => (
                                    <li key={'b' + index}>{error}</li>
                                ))}
                                {validationResult.parameterValidations && validationResult.parameterValidations.map((error, index) => (
                                    <li key={'p' + index}>{error}</li>
                                ))}
                            </ul>
                        </>
                        :
                        null
                    }

                    {validationResult && validationResult.warnings.length > 0 ?
                        <>
                            <div style={{ display: 'flex', alignItems: 'end', fontSize: '1.1em' }}>
                                <WarningIcon style={{ color: 'goldenrod', marginRight: '5px' }} />
                                {__t('warnings')}
                            </div>
                            <ul style={{ paddingLeft: '30px' }}>
                                {validationResult.warnings.map((warning, index) => (
                                    <li key={index}>{warning}</li>
                                ))
                                }
                            </ul>
                        </>
                        :
                        null
                    }
                </div>
            </div>
        </Drawer>
    )
}

export default ContextValidationDrawer;